const devFbId = '26396991252';
const productionFbId = '60854893843';

const isoConfig = {
  googlePublisherId: '7449',
  fbid: __DEV__ ? devFbId : productionFbId,
};

export default isoConfig;
